import React, { useState, memo } from 'react';
import { CheckIcon, StarIcon as StarIconLucide, ClockIcon, RocketIcon, ChevronLeftIcon, ChevronRightIcon, XIcon } from 'lucide-react';
import { CopiesAvailableCounter } from './CopiesAvailableCounter';
export const PricingSection = () => {
  const [hoveredBadge, setHoveredBadge] = useState(null);
  const [collectorBundleImageIndex, setCollectorBundleImageIndex] = useState(0);
  const [enlargedImage, setEnlargedImage] = useState(null);
  const collectorBundleImages = ['https://uploadthingy.s3.us-west-1.amazonaws.com/ucTh24qJQz1i6rVWh5876N/TIME_TRAVELLERS_COLLECTOR_BUNDLEC.png', 'https://uploadthingy.s3.us-west-1.amazonaws.com/i3DKchuX8RMmzYrqAhpK13/foam-trucker-hat-black-one-size-right-front-6914c3a4781f3.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/rbwPKtwrCHTaFNqFeaH2fA/enhanced-matte-paper-framed-poster-%28in%29-white-10x10-front-6914bc8d8b378.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/2eQBo88LwYLe7TLxEHMDQe/white-glossy-mug-white-11-oz-handle-on-left-6914d9d1888e4.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/dsPxuWW7a4Xja3nWKMPU8M/all-over-print-tote-bag-yellow-15x15-mockup-69123afa061d2.jpg'];
  const nextCollectorImage = () => {
    setCollectorBundleImageIndex(prev => prev === collectorBundleImages.length - 1 ? 0 : prev + 1);
  };
  const prevCollectorImage = () => {
    setCollectorBundleImageIndex(prev => prev === 0 ? collectorBundleImages.length - 1 : prev - 1);
  };
  const handleImageClick = (index: number) => {
    // Solo permitir ampliar si NO es la primera imagen (portada)
    if (index !== 0) {
      setEnlargedImage(collectorBundleImages[index]);
    }
  };
  const handleMainImageClick = (imageUrl: string) => {
    setEnlargedImage(imageUrl);
  };
  const closeEnlargedImage = () => {
    setEnlargedImage(null);
  };
  const editions = [{
    image: 'https://cdn.magicpatterns.com/uploads/ewSrEYsf3d6aAxsfRJbJ5B/BACK_IN_TIME_-_DIGITAL11v2.png',
    name: 'DIGITAL EDITION',
    emoji: '📱',
    originalPrice: '$47.97',
    currentPrice: '$29.97',
    features: ['Back In Time - 40th Anniversary Collectors Edition (1985-2025) | Digital', 'Instant Download'],
    cta: '⚡ GET DIGITAL EDITION',
    purchaseUrl: 'https://legendaryreads.com/cart/42185022439506:1',
    popular: false,
    borderColor: 'border-transparent bg-gradient-to-br from-amber-400/20 via-yellow-500/20 to-orange-500/20',
    hoverBorderColor: 'hover:from-amber-400/30 hover:via-yellow-500/30 hover:to-orange-500/30',
    shadow: 'hover:shadow-[0_0_20px_rgba(251,191,36,0.3)]',
    ctaClass: 'bg-gradient-to-br from-amber-400/90 via-yellow-500/90 to-orange-500/90 hover:from-amber-500 hover:via-yellow-600 hover:to-orange-600 text-black shadow-[0_0_15px_rgba(251,191,36,0.4)] hover:shadow-[0_0_20px_rgba(251,191,36,0.6)] border border-amber-300/30 font-semibold uppercase text-base tracking-wide',
    badge: {
      text: 'FOR CASUAL READERS',
      tooltip: 'Start Reading Today',
      icon: <ClockIcon className="h-3.5 w-3.5" data-id="element-260" />,
      gradient: 'bg-gradient-to-br from-amber-400/80 via-yellow-500/80 to-orange-500/80',
      textColor: 'text-black',
      glow: 'shadow-[0_0_12px_rgba(251,191,36,0.4)]'
    }
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/drsCGCcawJQmxdkJUsQyKs/Holiday_Edition_Digital_Set.png',
    name: 'HOLIDAY DIGITAL SET',
    emoji: '🎄',
    originalPrice: '$119.97',
    currentPrice: '$59.97',
    features: ['Back In Time - 40th Anniversary Collectors Edition (1985-2025) | Digital', 'Special Supplement #1: BEHIND THE CLOCK TOWER: Stories From The Set | Digital', 'Special Supplement #2: GREAT SCOTT! 40 Quotes For 40 Years | Digital', 'Special Supplement #3: TIME IMAGINATION DESTINY: The Philosophical And Cultural Legacy Of Bttf | Digital', 'Instant Download'],
    cta: '🎁 GET HOLIDAY DIGITAL SET',
    purchaseUrl: 'https://legendaryreads.com/cart/42231842701394:1',
    popular: true,
    isHero: true,
    borderColor: 'border-emerald-400/60 bg-gradient-to-br from-emerald-400/40 via-teal-500/40 to-green-600/40',
    hoverBorderColor: 'hover:from-emerald-400/60 hover:via-teal-500/60 hover:to-green-600/60 hover:border-emerald-300/80',
    shadow: 'shadow-[0_0_40px_rgba(16,185,129,0.6)] hover:shadow-[0_0_60px_rgba(16,185,129,0.8)]',
    ctaClass: 'bg-gradient-to-br from-emerald-400 via-teal-500 to-green-600 hover:from-emerald-500 hover:via-teal-600 hover:to-green-700 text-white shadow-[0_0_30px_rgba(16,185,129,0.8)] hover:shadow-[0_0_40px_rgba(16,185,129,1)] border-2 border-emerald-300/60 font-bold uppercase text-base tracking-wide animate-pulse',
    badge: {
      text: 'BEST WAY TO EXPERIENCE THE 40TH ANNIVERSARY',
      tooltip: 'Recommended Choice',
      icon: <StarIconLucide className="h-3.5 w-3.5 fill-current" data-id="element-261" />,
      gradient: 'bg-gradient-to-br from-emerald-400 via-teal-500 to-green-600',
      textColor: 'text-white',
      glow: 'shadow-[0_0_30px_rgba(16,185,129,0.8)]'
    }
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pSD1kcciQ8RbkUdnckm8uJ/PREMIUM_EDITION_V1.2.png',
    name: 'PREMIUM HARDCOVER EDITION',
    emoji: '⭐',
    originalPrice: '$127.97',
    currentPrice: '$94.97',
    features: ['Back In Time - 40th Anniversary Collectors Edition (1985-2025) | Premium Hardcover Book', 'Special Supplement #1: BEHIND THE CLOCK TOWER: Stories From The Set | Digital', 'Special Supplement #2: GREAT SCOTT! 40 Quotes For 40 Years | Digital', 'Special Supplement #3: TIME IMAGINATION DESTINY: The Philosophical And Cultural Legacy Of Bttf | Digital', 'Delivers in 14 days'],
    cta: '⭐ GET PREMIUM HARDCOVER EDITION',
    purchaseUrl: 'https://legendaryreads.com/cart/42193918787666:1',
    popular: false,
    borderColor: 'border-transparent bg-gradient-to-br from-rose-600/20 via-red-700/20 to-red-900/20',
    hoverBorderColor: 'hover:from-rose-600/35 hover:via-red-700/35 hover:to-red-900/35',
    shadow: 'hover:shadow-[0_0_25px_rgba(225,29,72,0.4)]',
    ctaClass: 'bg-gradient-to-br from-rose-600/90 via-red-700/90 to-red-900/90 hover:from-rose-700 hover:via-red-800 hover:to-red-950 text-white shadow-[0_0_15px_rgba(225,29,72,0.5)] hover:shadow-[0_0_25px_rgba(225,29,72,0.7)] border border-rose-400/30 font-semibold uppercase text-base tracking-wide',
    badge: {
      text: 'FOR COLLECTORS WHO WANT IT ON THEIR SHELF',
      tooltip: 'Physical Edition',
      icon: <StarIconLucide className="h-3.5 w-3.5 fill-current" data-id="element-262" />,
      gradient: 'bg-gradient-to-br from-rose-600/80 via-red-700/80 to-red-900/80',
      textColor: 'text-white',
      glow: 'shadow-[0_0_15px_rgba(225,29,72,0.5)]'
    }
  }, {
    image: collectorBundleImages[collectorBundleImageIndex],
    name: "TIME TRAVELER'S COLLECTOR BUNDLE",
    emoji: '🚀',
    originalPrice: '$419.97',
    currentPrice: '$249.97',
    features: ['Back In Time - 40th Anniversary Collectors Edition (1985-2025) | Premium Hardcover Book', 'Special Supplement #1: BEHIND THE CLOCK TOWER: Stories From The Set | Digital', 'Special Supplement #2: GREAT SCOTT! 40 Quotes For 40 Years | Digital', 'Special Supplement #3: TIME IMAGINATION DESTINY: The Philosophical And Cultural Legacy Of Bttf | Digital', 'Back In Time Audiobook Experience', 'Hill Valley 1985, Limited Vintage Trucker Hat', "Flux Energy Core Collector's Framed Print | 10×10 Limited Edition", 'Time Machine Heritage Tote | Back In Time Edition', '40 Years Travelling Through Time Commemorative Gloss Black Mug', 'Priority Shipping'],
    cta: "🚀 GET TIME TRAVELER'S COLLECTOR BUNDLE",
    purchaseUrl: 'https://legendaryreads.com/cart/42237474865234:1,42211298443346:1,42210458140754:1,42209233633362:1,42194662064210:1,42193919049810:1',
    popular: false,
    borderColor: 'border-transparent bg-gradient-to-br from-purple-500/20 via-violet-600/20 to-indigo-700/20',
    hoverBorderColor: 'hover:from-purple-500/35 hover:via-violet-600/35 hover:to-indigo-700/35',
    shadow: 'hover:shadow-[0_0_25px_rgba(139,92,246,0.4)]',
    ctaClass: 'bg-gradient-to-br from-purple-500/90 via-violet-600/90 to-indigo-700/90 hover:from-purple-600 hover:via-violet-700 hover:to-indigo-800 text-white shadow-[0_0_15px_rgba(139,92,246,0.5)] hover:shadow-[0_0_25px_rgba(139,92,246,0.7)] border border-purple-400/30 font-semibold uppercase text-base tracking-wide',
    badge: {
      text: 'FOR TRUE COLLECTORS WHO WANT EVERYTHING',
      tooltip: 'Complete Collection',
      icon: <RocketIcon className="h-3.5 w-3.5" data-id="element-263" />,
      gradient: 'bg-gradient-to-br from-purple-500/80 via-violet-600/80 to-indigo-700/80',
      textColor: 'text-white',
      glow: 'shadow-[0_0_15px_rgba(139,92,246,0.5)]'
    },
    hasCarousel: true
  }];
  return <section className="py-6 md:py-8 bg-bttf-bg border-t border-b border-bttf-subtext/20" id="pricing" data-id="element-264">
      <div className="container mx-auto px-4" data-id="element-265">
        <div className="text-center mb-6 md:mb-10" data-id="element-266">
          <div className="flex justify-center mb-2" data-id="element-267">
            <StarIcon className="h-8 w-8 text-bttf-primary fill-current shadow-neon-orange" data-id="element-268" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold font-future tracking-wide bg-gradient-main text-transparent bg-clip-text mb-2" data-id="element-269">
            Special 40th Anniversary Collector's Offer
          </h2>
          <div className="w-20 h-1 bg-bttf-primary mx-auto mb-3" data-id="element-270"></div>
          <div className="mb-20 md:mb-24" data-id="element-271">
            <CopiesAvailableCounter data-id="element-272" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-6 max-w-7xl mx-auto items-start" data-id="element-273">
          {editions.map((edition, index) => <a key={index} href={edition.purchaseUrl} className={`block bg-bttf-bg/80 rounded-lg overflow-visible border-2 ${edition.borderColor} ${edition.hoverBorderColor} backdrop-blur-sm ${edition.shadow} transition-all duration-300 relative pt-14 md:pt-10 cursor-pointer ${edition.isHero ? 'z-20 md:scale-110 hover:scale-[1.02] md:hover:scale-[1.13]' : 'z-10 hover:scale-[1.02]'}`} data-id="element-274">
              {/* Badge */}
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 z-10 pointer-events-none w-full px-2" data-id="element-275">
                <div className="relative group flex justify-center" data-id="element-276">
                  <div className={`plan-badge flex items-center gap-1.5 rounded-full ${edition.badge.gradient} ${edition.badge.textColor} ${edition.badge.glow} font-medium uppercase tracking-wider transition-all duration-150 border border-white/20 text-center px-3 py-2 text-xs max-w-[85%]`} style={{
                letterSpacing: '0.02em'
              }} aria-label={edition.badge.text} data-id="element-277">
                    {edition.badge.icon}
                    <span className="leading-tight" data-id="element-278">{edition.badge.text}</span>
                  </div>
                </div>
              </div>
              <div className="p-6" data-id="element-279">
                {/* Image with optional carousel */}
                <div className="flex justify-center mb-6 relative" data-id="element-280">
                  {edition.hasCarousel ? <div className="relative w-full max-w-[224px] group" data-id="element-281">
                      <div className="aspect-square w-full rounded-lg overflow-hidden" onClick={e => {
                  if (collectorBundleImageIndex !== 0) {
                    e.preventDefault();
                    handleImageClick(collectorBundleImageIndex);
                  }
                }} data-id="element-282">
                        <img src={edition.image} alt={`${edition.name} - Item ${collectorBundleImageIndex + 1}`} className="w-full h-full object-cover transition-opacity duration-300" data-id="element-283" />
                      </div>
                      {/* Carousel Navigation Buttons */}
                      <button onClick={e => {
                  e.preventDefault();
                  prevCollectorImage();
                }} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 bg-bttf-primary/90 hover:bg-bttf-primary text-bttf-text p-2 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-10" aria-label="Previous item" data-id="element-284">
                        <ChevronLeftIcon className="h-4 w-4" data-id="element-285" />
                      </button>
                      <button onClick={e => {
                  e.preventDefault();
                  nextCollectorImage();
                }} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 bg-bttf-primary/90 hover:bg-bttf-primary text-bttf-text p-2 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-10" aria-label="Next item" data-id="element-286">
                        <ChevronRightIcon className="h-4 w-4" data-id="element-287" />
                      </button>
                      {/* Carousel Dots */}
                      <div className="flex justify-center gap-1.5 mt-3" data-id="element-288">
                        {collectorBundleImages.map((_, imgIndex) => <button key={imgIndex} onClick={e => {
                    e.preventDefault();
                    setCollectorBundleImageIndex(imgIndex);
                  }} className={`w-2 h-2 rounded-full transition-all duration-300 ${imgIndex === collectorBundleImageIndex ? 'bg-bttf-primary shadow-neon-orange w-4' : 'bg-bttf-subtext/50 hover:bg-bttf-subtext'}`} aria-label={`Go to item ${imgIndex + 1}`} data-id="element-289" />)}
                      </div>
                    </div> : <div className="w-full max-w-[224px]" data-id="element-290">
                      <div className="aspect-square w-full rounded-lg overflow-hidden cursor-pointer hover:opacity-90 transition-opacity duration-300" onClick={e => {
                  e.preventDefault();
                  handleMainImageClick(edition.image);
                }} data-id="element-291">
                        <img src={edition.image} alt={edition.name} className="w-full h-full object-cover" data-id="element-292" />
                      </div>
                    </div>}
                </div>
                <div className="text-center mb-6" data-id="element-293">
                  <h3 className="text-xl font-bold text-white font-future" data-id="element-294">
                    {edition.name}
                  </h3>
                  <div className="mt-2" data-id="element-295">
                    <span className={`text-gray-400 line-through ${edition.isHero ? 'text-xl' : 'text-lg'}`} data-id="element-296">
                      {edition.originalPrice}
                    </span>
                    <span className={`text-bttf-accent font-bold ml-2 ${edition.isHero ? 'text-3xl' : 'text-2xl'}`} data-id="element-297">
                      {edition.currentPrice}
                    </span>
                  </div>

                  {/* Shop Pay Payment Info */}
                  {index >= 1 && <div className="mt-3 px-3 py-2 bg-black/30 rounded-lg border border-white/10" data-id="element-298">
                      <div className="flex items-center justify-center gap-2 mb-1" data-id="element-299">
                        <span className="text-gray-300 text-xs" data-id="element-300">
                          or 4 payments of
                        </span>
                        <span className="text-bttf-accent font-bold text-sm" data-id="element-301">
                          {index === 1 && '$15'}
                          {index === 2 && '$23.75'}
                          {index === 3 && '$62.50'}
                        </span>
                      </div>
                      <div className="flex items-center justify-center gap-1.5" data-id="element-302">
                        <span className="text-gray-400 text-xs" data-id="element-303">with</span>
                        <img src="https://cdn.magicpatterns.com/uploads/sSzxmJmvJ5ddbjuz1Lh65R/Shop_Pay_logo_purple.png" alt="Shop Pay" className="h-5 inline-block" data-id="element-304" />
                      </div>
                      <p className="text-gray-400 text-[10px] mt-1" data-id="element-305">
                        Biweekly interest-free payments
                      </p>
                    </div>}

                  {/* Shipping Badge */}
                  <div className="mt-4" data-id="element-306">
                    {index === 0 && <div className="inline-block bg-gradient-to-br from-amber-400/80 via-yellow-500/80 to-orange-500/80 text-black font-semibold px-4 py-2 rounded-lg shadow-[0_0_15px_rgba(251,191,36,0.5)] border border-amber-300/30" data-id="element-307">
                        <span className="text-base tracking-wide" data-id="element-308">
                          ⚡ INSTANT ACCESS
                        </span>
                      </div>}
                    {index === 1 && <div className="inline-block bg-gradient-to-br from-emerald-400 via-teal-500 to-green-600 text-white font-semibold px-4 py-2 rounded-lg shadow-[0_0_30px_rgba(16,185,129,0.8)] animate-pulse border-2 border-emerald-300/50" data-id="element-309">
                        <span className="text-base tracking-wide" data-id="element-310">
                          ⚡ INSTANT DOWNLOAD
                        </span>
                      </div>}
                    {index === 2 && <div className="inline-block bg-gradient-to-br from-rose-600/80 via-red-700/80 to-red-900/80 text-white font-semibold px-4 py-2 rounded-lg shadow-[0_0_15px_rgba(225,29,72,0.5)] border border-rose-400/30" data-id="element-311">
                        <span className="text-base tracking-wide" data-id="element-312">
                          📦 FREE SHIPPING
                        </span>
                      </div>}
                    {index === 3 && <div className="inline-block bg-gradient-to-br from-purple-500/80 via-violet-600/80 to-indigo-700/80 text-white font-semibold px-4 py-2 rounded-lg shadow-[0_0_15px_rgba(139,92,246,0.5)] border border-purple-400/30" data-id="element-313">
                        <span className="text-base tracking-wide" data-id="element-314">
                          🚀 PRIORITY FREE SHIPPING
                        </span>
                      </div>}
                  </div>
                </div>
                <ul className="mb-6" data-id="element-315">
                  {edition.features.map((feature, i) => <li key={i} className="flex items-start mb-2 text-gray-200 text-sm" data-id="element-316">
                      <CheckIcon className="text-bttf-primary mr-2 mt-0.5 flex-shrink-0 h-4 w-4" data-id="element-317" />
                      <span data-id="element-318">{feature}</span>
                    </li>)}
                </ul>
                <div className={`block text-center py-3 rounded-md transition-all ${edition.ctaClass} transform hover:scale-105 pointer-events-none`} data-id="element-319">
                  {edition.cta}
                </div>
              </div>
            </a>)}
        </div>
      </div>
      {/* Image Enlargement Modal */}
      {enlargedImage && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm p-4" onClick={closeEnlargedImage} data-id="element-320">
          <button onClick={closeEnlargedImage} className="absolute top-4 right-4 text-bttf-text hover:text-bttf-primary transition-colors bg-bttf-bg/50 rounded-full p-2 hover:bg-bttf-bg/80" aria-label="Close enlarged image" data-id="element-321">
            <XIcon className="h-8 w-8" data-id="element-322" />
          </button>
          <div className="relative max-w-4xl max-h-[90vh] w-full" data-id="element-323">
            <img src={enlargedImage} alt={`${editions[3].name} - Item ${collectorBundleImageIndex + 1}`} className="w-full h-full object-contain rounded-lg" onClick={e => e.stopPropagation()} data-id="element-324" />
          </div>
        </div>}
    </section>;
};
const StarIcon = ({
  className
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-325">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-326"></polygon>
  </svg>;